export default __webpack_public_path__ + "static/media/Snd_G_Starts.26fc9bf8.mp3";